import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import  tokenSlice  from "../features/authSlice";

export const store = configureStore({
  reducer: {
    auth: tokenSlice,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(),
});

setupListeners(store.dispatch);
